/**
 * NEDISO Konfigurator — Slot-System Datenmodell
 * Sprint 3, Phase 3.1
 *
 * 5 Raumtypen mit definierten Slots fuer Produkt-Kategorien.
 * Jeder Slot hat: Position im 3D-Raum, kompatible Collections,
 * optional Groessen-Filter, Default-Produkt-Handle.
 *
 * Kompatibilitaets-Matrix prueft Slot-uebergreifende Abhaengigkeiten
 * (z.B. Display-Groesse → passende Halterung).
 */
(function () {
  'use strict';

  /* ===================================================================
   * COLLECTION HANDLES → used by UI to fetch compatible products
   * =================================================================== */
  var COLLECTIONS = {
    displays:           'displays',
    led_walls:          'led-walls',
    kameras:            'kameras',
    audiokonferenz:     'audiokonferenz',
    lautsprecher:       'lautsprecher',
    prasentationssysteme: 'konferenz-prasentation',
    raumbuchungssysteme: 'raumbuchungssysteme',
    halterungen:        'halterungen-montage',
    steuerungen:        'steuerungen',
    media_player:       'media-player',
    signal_management:  'signal-management',
    kabel_adapter:      'kabel-adapter',
    software:           'software-lizenzen'
  };

  /* ===================================================================
   * ROOM TYPES — each with named slots
   * =================================================================== */
  var ROOM_TYPES = {

    /* --- Konferenzraum Medium (6-10 Personen) --- */
    konferenzraum_medium: {
      name: 'Konferenzraum (6–10 Personen)',
      description: 'Klassischer Meetingraum mit Display, Kamera und Audio.',
      icon: 'meeting',
      camera: { pos: { x: 5, y: 2.4, z: 5 }, target: { x: 0, y: 1.8, z: 0 } },
      slots: [
        {
          id: 'display_main',
          label: 'Hauptdisplay',
          position: { x: 0, y: 2.2, z: -3.8 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 1.6, y: 0.9, z: 0.05 },
          required: true,
          collections: [COLLECTIONS.displays],
          sizeFilter: { min: 55, max: 98, metafield: 'display_size' },
          defaultHandle: null
        },
        {
          id: 'camera_main',
          label: 'PTZ-Kamera',
          position: { x: 0, y: 3.2, z: -3.6 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.2, y: 0.15, z: 0.15 },
          required: true,
          collections: [COLLECTIONS.kameras],
          defaultHandle: null
        },
        {
          id: 'audio_speaker',
          label: 'Konferenz-Lautsprecher',
          position: { x: 0, y: 0.85, z: 0 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.3, y: 0.05, z: 0.3 },
          required: true,
          collections: [COLLECTIONS.audiokonferenz, COLLECTIONS.lautsprecher],
          defaultHandle: null
        },
        {
          id: 'wireless_presentation',
          label: 'Wireless Presentation',
          position: { x: -1.2, y: 0.85, z: 0 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.15, y: 0.03, z: 0.12 },
          required: false,
          collections: [COLLECTIONS.prasentationssysteme],
          defaultHandle: null
        },
        {
          id: 'room_booking',
          label: 'Raumbuchungssystem',
          position: { x: 3.9, y: 1.5, z: 2.5 },
          rotation: { x: 0, y: Math.PI * -0.5, z: 0 },
          scale: { x: 0.25, y: 0.18, z: 0.02 },
          required: false,
          collections: [COLLECTIONS.raumbuchungssysteme],
          defaultHandle: null
        },
        {
          id: 'mounting',
          label: 'Wandhalterung',
          position: { x: 0, y: 2.2, z: -3.7 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.4, y: 0.4, z: 0.1 },
          required: true,
          collections: [COLLECTIONS.halterungen],
          autoMatch: true,
          defaultHandle: 'chief-chief-xsm1u-fixe-wandhalterung'
        }
      ]
    },

    /* --- Huddle Room (2-5 Personen) --- */
    huddle_room: {
      name: 'Huddle Room (2–5 Personen)',
      description: 'Kompakter Besprechungsraum fuer schnelle Meetings.',
      icon: 'huddle',
      camera: { pos: { x: 3, y: 2, z: 3 }, target: { x: 0, y: 1.5, z: 0 } },
      slots: [
        {
          id: 'display_main',
          label: 'Display',
          position: { x: 0, y: 1.8, z: -2.2 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 1.2, y: 0.68, z: 0.05 },
          required: true,
          collections: [COLLECTIONS.displays],
          sizeFilter: { min: 43, max: 65, metafield: 'display_size' },
          defaultHandle: null
        },
        {
          id: 'camera_main',
          label: 'Kamera',
          position: { x: 0, y: 2.4, z: -2.1 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.15, y: 0.1, z: 0.1 },
          required: true,
          collections: [COLLECTIONS.kameras],
          defaultHandle: null
        },
        {
          id: 'audio_speaker',
          label: 'Freisprecheinrichtung',
          position: { x: 0, y: 0.75, z: 0 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.25, y: 0.04, z: 0.25 },
          required: true,
          collections: [COLLECTIONS.audiokonferenz],
          defaultHandle: null
        },
        {
          id: 'wireless_presentation',
          label: 'Wireless Presentation',
          position: { x: -0.8, y: 0.75, z: 0 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.12, y: 0.03, z: 0.1 },
          required: false,
          collections: [COLLECTIONS.prasentationssysteme],
          defaultHandle: null
        },
        {
          id: 'mounting',
          label: 'Halterung',
          position: { x: 0, y: 1.8, z: -2.15 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.3, y: 0.3, z: 0.08 },
          required: true,
          collections: [COLLECTIONS.halterungen],
          autoMatch: true,
          defaultHandle: 'chief-chief-xsm1u-fixe-wandhalterung'
        }
      ]
    },

    /* --- Schulungsraum (10-30 Personen) --- */
    schulungsraum: {
      name: 'Schulungsraum (10–30 Personen)',
      description: 'Grosser Raum fuer Trainings, Workshops und Praesentationen.',
      icon: 'training',
      camera: { pos: { x: 0, y: 2.5, z: 8 }, target: { x: 0, y: 2, z: 0 } },
      slots: [
        {
          id: 'display_main',
          label: 'Hauptdisplay / Interactive Whiteboard',
          position: { x: 0, y: 2.4, z: -5 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 2, y: 1.12, z: 0.05 },
          required: true,
          collections: [COLLECTIONS.displays],
          sizeFilter: { min: 65, max: 98, metafield: 'display_size' },
          defaultHandle: null
        },
        {
          id: 'display_secondary',
          label: 'Zweites Display (optional)',
          position: { x: 3.5, y: 2.4, z: -5 },
          rotation: { x: 0, y: -0.15, z: 0 },
          scale: { x: 1.4, y: 0.79, z: 0.05 },
          required: false,
          collections: [COLLECTIONS.displays],
          sizeFilter: { min: 55, max: 75, metafield: 'display_size' },
          defaultHandle: null
        },
        {
          id: 'camera_main',
          label: 'PTZ-Kamera',
          position: { x: 0, y: 3.8, z: -4.8 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.2, y: 0.15, z: 0.15 },
          required: true,
          collections: [COLLECTIONS.kameras],
          defaultHandle: null
        },
        {
          id: 'camera_rear',
          label: 'Rueckkamera (Publikum)',
          position: { x: 0, y: 3.5, z: 6 },
          rotation: { x: 0, y: Math.PI, z: 0 },
          scale: { x: 0.2, y: 0.15, z: 0.15 },
          required: false,
          collections: [COLLECTIONS.kameras],
          defaultHandle: null
        },
        {
          id: 'audio_speaker',
          label: 'Raumlautsprecher',
          position: { x: -4, y: 3.2, z: 0 },
          rotation: { x: 0, y: Math.PI * 0.5, z: 0 },
          scale: { x: 0.3, y: 0.3, z: 0.2 },
          required: true,
          collections: [COLLECTIONS.lautsprecher, COLLECTIONS.audiokonferenz],
          defaultHandle: null
        },
        {
          id: 'microphone_ceiling',
          label: 'Deckenmikrofon',
          position: { x: 0, y: 4, z: 2 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.15, y: 0.05, z: 0.15 },
          required: false,
          collections: [COLLECTIONS.audiokonferenz],
          defaultHandle: null
        },
        {
          id: 'wireless_presentation',
          label: 'Wireless Presentation',
          position: { x: -1, y: 0.85, z: -3 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.15, y: 0.03, z: 0.12 },
          required: false,
          collections: [COLLECTIONS.prasentationssysteme],
          defaultHandle: null
        },
        {
          id: 'mounting',
          label: 'Wandhalterung',
          position: { x: 0, y: 2.4, z: -4.95 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.5, y: 0.5, z: 0.1 },
          required: true,
          collections: [COLLECTIONS.halterungen],
          autoMatch: true,
          defaultHandle: 'chief-chief-xtm1u-neigbare-wandhalterung'
        }
      ]
    },

    /* --- Boardroom Premium (8-16 Personen) --- */
    boardroom: {
      name: 'Boardroom Premium (8–16 Personen)',
      description: 'Repraesentativer Sitzungssaal mit Premium-Ausstattung.',
      icon: 'boardroom',
      camera: { pos: { x: 6, y: 2.6, z: 6 }, target: { x: 0, y: 2, z: 0 } },
      slots: [
        {
          id: 'display_main',
          label: 'Hauptdisplay / LED-Wall',
          position: { x: 0, y: 2.4, z: -4.5 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 2.4, y: 1.35, z: 0.05 },
          required: true,
          collections: [COLLECTIONS.displays, COLLECTIONS.led_walls],
          sizeFilter: { min: 75, max: 120, metafield: 'display_size' },
          defaultHandle: null
        },
        {
          id: 'display_side_l',
          label: 'Seitendisplay Links',
          position: { x: -4.5, y: 2.2, z: 0 },
          rotation: { x: 0, y: Math.PI * 0.5, z: 0 },
          scale: { x: 1.4, y: 0.79, z: 0.05 },
          required: false,
          collections: [COLLECTIONS.displays],
          sizeFilter: { min: 55, max: 75, metafield: 'display_size' },
          defaultHandle: null
        },
        {
          id: 'display_side_r',
          label: 'Seitendisplay Rechts',
          position: { x: 4.5, y: 2.2, z: 0 },
          rotation: { x: 0, y: Math.PI * -0.5, z: 0 },
          scale: { x: 1.4, y: 0.79, z: 0.05 },
          required: false,
          collections: [COLLECTIONS.displays],
          sizeFilter: { min: 55, max: 75, metafield: 'display_size' },
          defaultHandle: null
        },
        {
          id: 'camera_main',
          label: 'PTZ-Kamera Haupt',
          position: { x: 0, y: 3.5, z: -4.3 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.2, y: 0.15, z: 0.15 },
          required: true,
          collections: [COLLECTIONS.kameras],
          defaultHandle: null
        },
        {
          id: 'camera_tracking',
          label: 'Tracking-Kamera',
          position: { x: -2, y: 3.5, z: -4.3 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.2, y: 0.15, z: 0.15 },
          required: false,
          collections: [COLLECTIONS.kameras],
          defaultHandle: null
        },
        {
          id: 'audio_speaker',
          label: 'Konferenz-Audio',
          position: { x: 0, y: 0.85, z: 0 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.35, y: 0.05, z: 0.35 },
          required: true,
          collections: [COLLECTIONS.audiokonferenz, COLLECTIONS.lautsprecher],
          defaultHandle: null
        },
        {
          id: 'wireless_presentation',
          label: 'Wireless Presentation',
          position: { x: -1.5, y: 0.85, z: 0 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.15, y: 0.03, z: 0.12 },
          required: true,
          collections: [COLLECTIONS.prasentationssysteme],
          defaultHandle: null
        },
        {
          id: 'room_booking',
          label: 'Raumbuchungssystem',
          position: { x: 4.8, y: 1.5, z: 4 },
          rotation: { x: 0, y: Math.PI * -0.5, z: 0 },
          scale: { x: 0.25, y: 0.18, z: 0.02 },
          required: false,
          collections: [COLLECTIONS.raumbuchungssysteme],
          defaultHandle: null
        },
        {
          id: 'mounting',
          label: 'Wandhalterung',
          position: { x: 0, y: 2.4, z: -4.45 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.5, y: 0.5, z: 0.1 },
          required: true,
          collections: [COLLECTIONS.halterungen],
          autoMatch: true,
          defaultHandle: 'chief-chief-xtm1u-neigbare-wandhalterung'
        },
        {
          id: 'signal_processor',
          label: 'Signal-Management',
          position: { x: -4.5, y: 0.5, z: -4 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.4, y: 0.08, z: 0.3 },
          required: false,
          collections: [COLLECTIONS.signal_management, COLLECTIONS.steuerungen],
          defaultHandle: null
        }
      ]
    },

    /* --- Digital Signage Einzelinstallation --- */
    digital_signage_single: {
      name: 'Digital Signage (Einzelinstallation)',
      description: 'Ein Display mit Player fuer Infoscreens, Werbung, Wegeleitung.',
      icon: 'signage',
      camera: { pos: { x: 3, y: 1.8, z: 3 }, target: { x: 0, y: 1.6, z: 0 } },
      slots: [
        {
          id: 'display_main',
          label: 'Display',
          position: { x: 0, y: 1.8, z: -1 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 1.2, y: 0.68, z: 0.05 },
          required: true,
          collections: [COLLECTIONS.displays],
          sizeFilter: { min: 32, max: 98, metafield: 'display_size' },
          defaultHandle: null
        },
        {
          id: 'media_player',
          label: 'Media Player',
          position: { x: 0.6, y: 1.3, z: -0.9 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.12, y: 0.03, z: 0.1 },
          required: true,
          collections: [COLLECTIONS.media_player],
          defaultHandle: 'brightsign-brightsign-hd1025'
        },
        {
          id: 'mounting',
          label: 'Halterung',
          position: { x: 0, y: 1.8, z: -0.95 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.35, y: 0.35, z: 0.08 },
          required: true,
          collections: [COLLECTIONS.halterungen],
          autoMatch: true,
          defaultHandle: 'chief-chief-xsm1u-fixe-wandhalterung'
        },
        {
          id: 'software',
          label: 'CMS Software',
          position: { x: -0.6, y: 1.3, z: -0.9 },
          rotation: { x: 0, y: 0, z: 0 },
          scale: { x: 0.15, y: 0.15, z: 0.02 },
          required: false,
          collections: [COLLECTIONS.software],
          defaultHandle: null
        }
      ]
    }
  };

  /* ===================================================================
   * COMPATIBILITY MATRIX
   * Cross-slot dependencies (e.g. display size determines mounting)
   * =================================================================== */
  var COMPATIBILITY = [
    {
      name: 'display_to_mount',
      description: 'Display-Groesse bestimmt passende Halterung',
      sourceSlot: 'display_main',
      targetSlot: 'mounting',
      rule: function (sourceProduct, targetSlot) {
        /* Future: filter mounts by VESA pattern / max weight */
        return true;
      }
    },
    {
      name: 'camera_needs_display',
      description: 'Kamera nur sinnvoll mit Display',
      sourceSlot: 'display_main',
      targetSlot: 'camera_main',
      rule: function (sourceProduct) {
        return !!sourceProduct;
      }
    }
  ];

  /* ===================================================================
   * CONFIGURATION STATE
   * Tracks current room type + selected products per slot
   * =================================================================== */
  function ConfigState(roomTypeId) {
    this.roomTypeId = roomTypeId;
    this.roomType = ROOM_TYPES[roomTypeId];
    this.selections = {};
    this._listeners = [];

    if (!this.roomType) {
      throw new Error('Unknown room type: ' + roomTypeId);
    }

    /* Populate defaults */
    var self = this;
    this.roomType.slots.forEach(function (slot) {
      self.selections[slot.id] = {
        handle: slot.defaultHandle,
        product: null,
        loaded: false
      };
    });
  }

  ConfigState.prototype.setProduct = function (slotId, handle, productData) {
    this.selections[slotId] = {
      handle: handle,
      product: productData,
      loaded: !!productData
    };
    this._notify('product-change', { slotId: slotId, handle: handle, product: productData });
  };

  ConfigState.prototype.clearSlot = function (slotId) {
    this.selections[slotId] = { handle: null, product: null, loaded: false };
    this._notify('product-change', { slotId: slotId, handle: null, product: null });
  };

  ConfigState.prototype.getSlot = function (slotId) {
    return this.selections[slotId] || null;
  };

  ConfigState.prototype.getFilledSlots = function () {
    var filled = [];
    var self = this;
    this.roomType.slots.forEach(function (slot) {
      var sel = self.selections[slot.id];
      if (sel && sel.handle) {
        filled.push({ slot: slot, selection: sel });
      }
    });
    return filled;
  };

  ConfigState.prototype.getEmptyRequiredSlots = function () {
    var empty = [];
    var self = this;
    this.roomType.slots.forEach(function (slot) {
      if (!slot.required) return;
      var sel = self.selections[slot.id];
      if (!sel || !sel.handle) {
        empty.push(slot);
      }
    });
    return empty;
  };

  ConfigState.prototype.getTotalPrice = function () {
    var total = 0;
    var self = this;
    this.roomType.slots.forEach(function (slot) {
      var sel = self.selections[slot.id];
      if (sel && sel.product && sel.product.variants && sel.product.variants[0]) {
        total += sel.product.variants[0].price;
      }
    });
    return total;
  };

  ConfigState.prototype.on = function (cb) {
    this._listeners.push(cb);
  };

  ConfigState.prototype.off = function (cb) {
    this._listeners = this._listeners.filter(function (l) { return l !== cb; });
  };

  ConfigState.prototype._notify = function (type, data) {
    var evt = { type: type, state: this, data: data };
    this._listeners.forEach(function (cb) { cb(evt); });
  };

  /* ===================================================================
   * SERIALIZATION — URL-safe config encoding
   * =================================================================== */
  ConfigState.prototype.serialize = function () {
    var obj = { room: this.roomTypeId, slots: {} };
    var self = this;
    this.roomType.slots.forEach(function (slot) {
      var sel = self.selections[slot.id];
      if (sel && sel.handle) {
        obj.slots[slot.id] = sel.handle;
      }
    });
    return btoa(JSON.stringify(obj));
  };

  ConfigState.deserialize = function (encoded) {
    try {
      var obj = JSON.parse(atob(encoded));
      var state = new ConfigState(obj.room);
      Object.keys(obj.slots || {}).forEach(function (slotId) {
        state.selections[slotId] = {
          handle: obj.slots[slotId],
          product: null,
          loaded: false
        };
      });
      return state;
    } catch (e) {
      return null;
    }
  };

  /* ===================================================================
   * CART ITEMS — build array for /cart/add.js
   * =================================================================== */
  ConfigState.prototype.toCartItems = function () {
    var items = [];
    var self = this;
    this.roomType.slots.forEach(function (slot) {
      var sel = self.selections[slot.id];
      if (sel && sel.product && sel.product.variants && sel.product.variants[0]) {
        items.push({
          id: sel.product.variants[0].id,
          quantity: 1,
          properties: {
            '_config': self.roomTypeId,
            '_slot': slot.id,
            '_slot_label': slot.label
          }
        });
      }
    });
    return items;
  };

  /* ===================================================================
   * PRODUCT LOADER — batch-fetch defaults via StorefrontBridge
   * =================================================================== */
  ConfigState.prototype.loadDefaults = function (bridge) {
    var self = this;
    var promises = [];

    this.roomType.slots.forEach(function (slot) {
      var sel = self.selections[slot.id];
      if (sel && sel.handle && !sel.loaded) {
        var p = bridge.getProduct(sel.handle).then(function (product) {
          self.selections[slot.id].product = product;
          self.selections[slot.id].loaded = true;
          self._notify('product-loaded', { slotId: slot.id, product: product });
        }).catch(function () {
          /* Product not found — clear slot */
          self.selections[slot.id] = { handle: null, product: null, loaded: false };
        });
        promises.push(p);
      }
    });

    return Promise.all(promises);
  };

  /* ===================================================================
   * EXPOSE GLOBALLY
   * =================================================================== */
  window.nedisoConfigurator = {
    ROOM_TYPES: ROOM_TYPES,
    COLLECTIONS: COLLECTIONS,
    COMPATIBILITY: COMPATIBILITY,
    ConfigState: ConfigState,
    roomTypeIds: Object.keys(ROOM_TYPES)
  };

})();
